<template>
	<div class="advert-manage-container">
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.triggerSource" placeholder="请输入触发场景" />
				</el-col>
			</template>
		</QueryCard>
		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:selection="false"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template #header-left>
				<div class="title">风险处理列表</div>
			</template>
			<template #riskLevel="{ row }">
				<el-tag size="small" :type="getRiskType(row.riskLevel)">
					{{ row.riskLevel }}
				</el-tag>
			</template>
			<template #contractNo="{ row }">
				<el-tag size="small">{{ row.contractNo }}</el-tag>
			</template>
			<template #status="{ row }">
				<el-tag size="small" :type="getStatusType(row.status)">
					{{ row.status }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleShowDetail(row)">查看详情</el-button>
				<el-button type="text" @click="handleShowContract(row)">查看合同</el-button>
			</template>
		</BaseTable>

		<RiskPreventionDialog :dialogVisible.sync="dialogVisible" :data="currentRow" />
		<RiskPreventionContractDialog :dialogVisible.sync="dialogContractVisible" :data="currentRow" />
	</div>
</template>

<script>
	import RiskPreventionDialog from '@/components/compliance/riskPreventionDialog';
	import RiskPreventionContractDialog from '@/components/compliance/riskPreventionContractDialog';
	export default {
		components: {
			RiskPreventionDialog,
			RiskPreventionContractDialog,
		},
		data() {
			return {
				total: 2,
				query: {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [
					{
						project: '中山首府',
						business: '租赁',
						riskLevel: '严重',
						rule: '租期超20年，违反合同法规定',
						triggerScene: '租赁合同新签',
						triggerUser: '张三',
						warningTime: '2026-04-21 10:30:00',
						contractNo: 'HT202604001',
						status: '未读',
					},
					{
						project: '中山首府',
						business: '租赁',
						riskLevel: '紧急',
						rule: '租金低于底价15%，存在国有资产流失风险',
						triggerScene: '租赁合同新签',
						triggerUser: '李四',
						warningTime: '2026-04-21 09:15:00',
						contractNo: 'HT202604002',
						status: '未读',
					},
				],
				columns: [
					{ prop: 'project', label: '所属项目' },
					{ prop: 'business', label: '所属业务' },
					{ prop: 'riskLevel', label: '风险等级', slot: 'riskLevel' },
					{ prop: 'rule', label: '预警规则' },
					{ prop: 'triggerScene', label: '触发场景' },
					{ prop: 'triggerUser', label: '触发用户' },
					{ prop: 'warningTime', label: '预警时间' },
					{ prop: 'contractNo', label: '关联合同编号', slot: 'contractNo' },
					{ prop: 'status', label: '状态', slot: 'status' },
				],
				loading: false,
				currentRow: {},
				dialogVisible: false,
				dialogContractVisible: false,
			};
		},
		methods: {
			getRiskType(level) {
				const map = {
					严重: 'danger',
					紧急: 'warning',
					一般: 'info',
				};
				return map[level] || 'info';
			},
			getStatusType(status) {
				const map = {
					未读: 'info',
					已读: 'success',
					处理中: 'warning',
					已关闭: 'danger',
				};
				return map[status] || 'info';
			},
			getList() {},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
				this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleShowDetail(row) {
				this.currentRow = row;
				this.dialogVisible = true;
			},
			handleShowContract(row) {
				this.currentRow = row;
				this.dialogContractVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
		.title {
			padding-bottom: 10px;
			font-size: 20px;
			color: #333;
		}
	}
</style>
